import React, { useState } from "react";
import { FaWhatsapp, FaPhoneAlt, FaComments, FaTimes } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

export default function FloatingContactActions() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-[999] flex flex-col items-center gap-4">
      
      {/* WhatsApp & Call (shown only when open) */}
      <AnimatePresence>
        {open && (
          <>
            {/* WhatsApp */}
            <motion.a
              href="https://wa.me/917823900442" // <-- replace number
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0, y: 20 }}
              transition={{ duration: 0.25 }}
              className="bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600"
              aria-label="Chat on WhatsApp"
              title="Chat with us on WhatsApp"
            >
              <FaWhatsapp size={22} />
            </motion.a>

            {/* Call */}
            <motion.a
              href="tel:9884807480" // <-- replace number
              initial={{ opacity: 0, scale: 0, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0, y: 20 }}
              transition={{ duration: 0.25, delay: 0.05 }}
              className="bg-blue-500 text-white p-4 rounded-full shadow-lg hover:bg-blue-600"
              aria-label="Call us"
              title="Call Admissions Team"
            >
              <FaPhoneAlt size={20} />
            </motion.a>
          </>
        )}
      </AnimatePresence>

      {/* Main Toggle Button */}
      <button
        onClick={() => setOpen(!open)}
        className="bg-[#0C8AC4] text-white p-5 rounded-full shadow-xl hover:bg-[#0a78a8] transition"
        aria-label={open ? "Close contact options" : "Open contact options"}
        title={open ? "Close" : "Contact Us"}
      >
        {open ? <FaTimes size={22} /> : <FaComments size={22} />}
      </button>
    </div>
  );
}
